import { render } from "./WaitingListForm.vue?vue&type=template&id=5a6feae8"
import script from "./WaitingListForm.vue?vue&type=script&lang=js"
export * from "./WaitingListForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__